var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0786,
    cy: 17.3208,
    r: 16.1408,
    stroke: "#05B226",
    strokeWidth: 1.89892
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7418 13.9977C13.9216 13.9977 14.878 13.0412 14.878 11.8614C14.878 10.6815 13.9216 9.7251 12.7418 9.7251C11.5619 9.7251 10.6055 10.6815 10.6055 11.8614C10.6055 13.0412 11.5619 13.9977 12.7418 13.9977Z",
    fill: "#05B226"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4175 13.9977C24.5974 13.9977 25.5538 13.0412 25.5538 11.8614C25.5538 10.6815 24.5974 9.7251 23.4175 9.7251C22.2377 9.7251 21.2812 10.6815 21.2812 11.8614C21.2812 13.0412 22.2377 13.9977 23.4175 13.9977Z",
    fill: "#05B226"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5085 17.3207C25.9841 17.3207 25.5654 17.748 25.4996 18.2682C25.0339 21.9503 21.8905 24.7977 18.082 24.7977C14.2736 24.7977 11.1301 21.9503 10.6645 18.2682C10.5987 17.748 10.1799 17.3207 9.65558 17.3207H9.41821C8.89384 17.3207 8.46383 17.7471 8.51492 18.269C8.99117 23.1331 13.0927 26.934 18.082 26.934C23.0713 26.934 27.1729 23.1331 27.6492 18.269C27.7003 17.7471 27.2702 17.3207 26.7459 17.3207H26.5085Z",
    fill: "#05B226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellent);
export default __webpack_public_path__ + "static/media/Excellent.674fa82294773f757b34841af4216442.svg";
export { ForwardRef as ReactComponent };